import { render, staticRenderFns } from "./abroad.vue?vue&type=template&id=70d82437&scoped=true"
import script from "./abroad.vue?vue&type=script&lang=js"
export * from "./abroad.vue?vue&type=script&lang=js"
import style0 from "./abroad.vue?vue&type=style&index=0&id=70d82437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d82437",
  null
  
)

export default component.exports